import {
  Box,
  Container,
  IconButton,
  Tooltip,
  Typography,
  Fade,
  Checkbox,
  Button,
  Divider,
  Slider
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import { styled } from '@mui/styles'
import { useFilter } from '../../context/FilterContext/FilterContext'
import { FilterButton } from '../FilterButtons/FilterButton'
import { CheckedFilterButton } from '../FilterButtons/CheckedFilterButton'
import { formatter } from '../../utils/auxFunc'
import './Filter.css'

const labelColores = {
  inputProps: { 'aria-label': 'filtro de colores' }
}

const valueRendered = (value) => {
  return formatter().format(value)
}

const MonacoSlider = styled(Slider)({
  color: '#292929',
  height: 2,
  '& .MuiSlider-track': {
    border: 'none',
    height: '3px'
  },
  '& .MuiSlider-rail': {
    height: '1px'
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fafafa',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit'
    },
    '&:before': {
      display: 'none'
    }
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#292929',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)'
    },
    '& > *': {
      transform: 'rotate(45deg)'
    }
  }
})

const Filter = ({ toggleFilterMenu }) => {
  const {
    filter,
    colors,
    toggleColorsCheckboxes,
    handleSliderChange,
    applyFilter,
    resetFilter
  } = useFilter()

  return (
    <Container
      maxWidth="md"
      sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        minHeight="56px"
        mb={2}
      >
        <Typography variant="h5" color="secondary">
          Filtrar por
        </Typography>
        <Tooltip
          title="Cerrar"
          placement="bottom"
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 600 }}
        >
          <IconButton
            aria-label="cerrar filtro"
            size="large"
            onClick={() => {
              toggleFilterMenu()
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
      <Typography
        variant="subtitle1"
        color="secondary"
        mt={3}
        mb={1}
        sx={{ textTransform: 'uppercase' }}
      >
        colores
      </Typography>
      <Box className="slider" mb={3}>
        {colors?.map((color, index) => {
          return (
            <Tooltip
              key={color.idColor}
              title={color.description}
              placement="bottom"
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              sx={{ textTransform: 'capitalize', fontSize: '5rem' }}
            >
              <Checkbox
                {...labelColores}
                icon={
                  <FilterButton
                    colorOption={color.hex}
                    widthOption="3em"
                    heigthOption="3em"
                  />
                }
                name={color.description}
                value={color.idColor}
                checked={filter.color[index].isChecked} // para tomar el valor guardado en filter y controlar el estado
                checkedIcon={
                  <CheckedFilterButton
                    content={<CheckIcon />}
                    colorOption={color.hex}
                    widthOption="3em"
                    heigthOption="3em"
                  />
                }
                sx={{ padding: '5px' }}
                onChange={(e) => toggleColorsCheckboxes(e, index)}
              />
            </Tooltip>
          )
        })}
      </Box>
      <Divider />
      <Typography
        variant="subtitle1"
        color="secondary"
        mt={3}
        mb={1}
        sx={{ textTransform: 'uppercase' }}
      >
        precio
      </Typography>
      <Box>
        <MonacoSlider
          color="secondary"
          getAriaLabel={() => 'Rango de precios'}
          min={20}
          step={40}
          max={150000}
          value={filter.price}
          onChange={handleSliderChange}
          valueLabelDisplay="auto"
          getAriaValueText={valueRendered}
        />
      </Box>
      <Box display="flex" justifyContent="space-between" mb={5}>
        <Typography
          variant="subtitle1"
          color="secondary"
          mt={1}
          mb={1}
          sx={{ textTransform: 'capitalize' }}
        >
          desde {formatter().format(filter.price[0])}
        </Typography>
        <Typography
          variant="subtitle1"
          color="secondary"
          mt={1}
          mb={1}
          sx={{ textTransform: 'capitalize' }}
        >
          hasta {formatter().format(filter.price[1])}
        </Typography>
      </Box>
      <Box className="filterButtons">
        <Button
          variant="contained"
          color="secondary"
          sx={{
            fontSize: '1rem',
            fontWeight: '600',
            border: '1px solid #292929',
            width: '50%',
            maxWidth: '150px',
            textTransform: 'capitalize'
          }}
          onClick={resetFilter}
        >
          Borrar
        </Button>
        <Button
          variant="contained"
          color="secondary"
          sx={{
            fontSize: '1rem',
            fontWeight: '600',
            border: '1px solid #292929',
            width: '50%',
            maxWidth: '150px',
            textTransform: 'capitalize'
          }}
          onClick={applyFilter}
        >
          Aplicar
        </Button>
      </Box>
    </Container>
  )
}

export default Filter
